import { useTranslation } from 'react-i18next';
import type { PaymentStatus } from '../../../shared/utils';

type Tone = 'success' | 'pending' | 'danger' | 'neutral';

// AUTHORIZED is bank consent only — it must never render as completed.
const STATUS_DISPLAY: Record<PaymentStatus, { tone: Tone; labelKey: string }> =
  {
    CREATED: { tone: 'pending', labelKey: 'dashboard.created' },
    PENDING: { tone: 'pending', labelKey: 'dashboard.pending' },
    AUTHORIZED: { tone: 'pending', labelKey: 'dashboard.authorized' },
    EXECUTED: { tone: 'success', labelKey: 'dashboard.executed' },
    FAILED: { tone: 'danger', labelKey: 'dashboard.failed' },
    CANCELLED: { tone: 'neutral', labelKey: 'dashboard.cancelled' },
  };

export const PaymentStatusTag = ({ status }: { status: PaymentStatus }) => {
  const { t } = useTranslation();
  const display = STATUS_DISPLAY[status] ?? {
    tone: 'pending',
    labelKey: status,
  };
  return (
    <span className={`mc-tag mc-tag--${display.tone}`}>
      {t(display.labelKey)}
    </span>
  );
};
